"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var query_string_1 = __importDefault(require("query-string"));
var __1 = require("../");
var Config_1 = require("../../Config");
var utils_1 = require("../../utils/");
var parseMeasurement_1 = require("../../utils/parseMeasurement");
var shipmentDetailsConvertTime_1 = require("../../utils/shipmentDetailsConvertTime");
var spliMeasurement_1 = require("../../utils/spliMeasurement");
var Model_1 = require("../Model");
var Location_1 = require("./Location");
var ShipmentComment_1 = require("./ShipmentComment");
var ShipmentLog_1 = require("./ShipmentLog");
var ReturnableType;
(function (ReturnableType) {
    ReturnableType["Jar"] = "Jar";
    ReturnableType["Bag"] = "Bag";
    ReturnableType["Crate"] = "Crate";
    ReturnableType["CarBattery"] = "CarBattery";
})(ReturnableType = exports.ReturnableType || (exports.ReturnableType = {}));
var PROCESSED_SHIPMENT_STATUS;
(function (PROCESSED_SHIPMENT_STATUS) {
    PROCESSED_SHIPMENT_STATUS["PARCEL_RETURNED_TO_TRUNKRS"] = "PARCEL_RETURNED_TO_TRUNKRS";
    PROCESSED_SHIPMENT_STATUS["SHIPMENT_BACK_IN_PLANNING"] = "SHIPMENT_BACK_IN_PLANNING";
    PROCESSED_SHIPMENT_STATUS["SHIPMENT_NOT_AT_DEPOT"] = "SHIPMENT_NOT_AT_DEPOT";
    PROCESSED_SHIPMENT_STATUS["PARCEL_RETURN_ACCEPTED_BY_TRUNKRS"] = "PARCEL_RETURN_ACCEPTED_BY_TRUNKRS";
})(PROCESSED_SHIPMENT_STATUS = exports.PROCESSED_SHIPMENT_STATUS || (exports.PROCESSED_SHIPMENT_STATUS = {}));
var HUBLOG_STATE;
(function (HUBLOG_STATE) {
    HUBLOG_STATE["HUB_IN"] = "HUB_IN";
    HUBLOG_STATE["HUB_OUT"] = "HUB_OUT";
    HUBLOG_STATE["HUB_IN_CENTRAL"] = "HUB_IN_CENTRAL";
})(HUBLOG_STATE = exports.HUBLOG_STATE || (exports.HUBLOG_STATE = {}));
var Shipment = /** @class */ (function (_super) {
    __extends(Shipment, _super);
    function Shipment(id, trunkrsNumber, label, barcode, productId, senderId, recipientId, merchantId, weight, height, length, width, goods, remarks, merchantDeliveryRemark, historyDetails, neighborCardNumber) {
        var _this = _super.call(this, id) || this;
        _this.addressHistory = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/address-history/" + this.getId, Model_1.METHOD.GET)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.map(function (_a) {
                                var location = _a.location, timeStamp = _a.timeStamp;
                                return ({
                                    location: new Location_1.Location(location.id, location.address, location.postalCode, location.city, location.country, location.latitude, location.longitude),
                                    timeStamp: timeStamp,
                                });
                            })];
                }
            });
        }); };
        _this.getTourOverview = function () {
            return Shipment.makeRequest("/spatial/private/tour-overview/" + _this.getId, Model_1.METHOD.GET);
        };
        _this.getLatestRecipientIdLog = function () { return __awaiter(_this, void 0, void 0, function () {
            var logs, _a, _b, version0Log;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.getLogs];
                    case 1: return [4 /*yield*/, _b.apply(_a, [(_c.sent())])];
                    case 2:
                        logs = _c.sent();
                        version0Log = logs.find(function (log) { return log.getVersion === 0; });
                        return [2 /*return*/, version0Log && version0Log.getRecipientId];
                }
            });
        }); };
        _this.postPone = function (date) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (moment_1.default(date).isBefore(moment_1.default(), 'day')) {
                            throw new Error("Provided date is before the current date");
                        }
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/post-pone/" + this.getId, Model_1.METHOD.POST, { date: date })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.postPoneOnDepot = function () {
            return Shipment.makeRequest('/delivery/private/depot-postpone', Model_1.METHOD.PUT, { shipmentId: _this.getId });
        };
        _this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var id, result, _i, _a, key, setter;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = Shipment.checkIfExists({ value: this.getId, key: 'ID' });
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/" + id, Model_1.METHOD.GET)];
                    case 1:
                        result = (_b.sent()).result;
                        for (_i = 0, _a = Object.keys(result); _i < _a.length; _i++) {
                            key = _a[_i];
                            setter = lodash_1.camelCase("set-" + key);
                            if (Object.getOwnPropertyDescriptor(Shipment.prototype, setter)) {
                                ;
                                this[setter] = result[key];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.isDelivered = function () { return __awaiter(_this, void 0, void 0, function () {
            var shipmentLedger, states;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLogs];
                    case 1:
                        shipmentLedger = _a.sent();
                        return [4 /*yield*/, Promise.all(shipmentLedger.map(function (ledgerEntry) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, ledgerEntry];
                                    case 1: return [2 /*return*/, (_a.sent()).getState];
                                }
                            }); }); }))];
                    case 2:
                        states = _a.sent();
                        return [2 /*return*/, states.some(function (state) {
                                return state.getName === 'SHIPMENT_DELIVERED' ||
                                    state.getName === 'SHIPMENT_DELIVERED_TO_NEIGHBOR';
                            })];
                }
            });
        }); };
        _this.sortToRegion = function () { return __awaiter(_this, void 0, void 0, function () {
            var recipient, _a, _b, _c, location, _d, _e, _f, subco, _g, _h, _j, canTransit;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        _b = (_a = Shipment).checkIfExists;
                        _c = {
                            key: 'recipient'
                        };
                        return [4 /*yield*/, this.getRecipient];
                    case 1:
                        recipient = _b.apply(_a, [(_c.value = _k.sent(),
                                _c)]);
                        _e = (_d = Shipment).checkIfExists;
                        _f = {
                            key: 'location'
                        };
                        return [4 /*yield*/, recipient.getLocation];
                    case 2:
                        location = _e.apply(_d, [(_f.value = _k.sent(),
                                _f)]);
                        _h = (_g = Shipment).checkIfExists;
                        _j = {
                            key: 'subcontractor'
                        };
                        return [4 /*yield*/, __1.SubcoDigits.findSubcoByPostalCodeAndCountry(location.getPostalCode, location.getCountry)];
                    case 3:
                        subco = _h.apply(_g, [(_j.value = _k.sent(),
                                _j)]);
                        return [4 /*yield*/, this.canTransitToState("SHIPMENT_SORTED")];
                    case 4:
                        canTransit = _k.sent();
                        if (!canTransit) return [3 /*break*/, 7];
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/sort-shipment/" + this.getId, Model_1.METHOD.POST)];
                    case 5:
                        _k.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 6:
                        _k.sent();
                        _k.label = 7;
                    case 7: return [2 /*return*/, subco.getTag];
                }
            });
        }); };
        _this.belongsToRegion = function (region, subcoId) { return __awaiter(_this, void 0, void 0, function () {
            var recipient, _a, _b, _c, location, _d, _e, _f, subco, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        _b = (_a = Shipment).checkIfExists;
                        _c = {
                            key: 'recipient'
                        };
                        return [4 /*yield*/, this.getRecipient];
                    case 1:
                        recipient = _b.apply(_a, [(_c.value = _k.sent(),
                                _c)]);
                        _e = (_d = Shipment).checkIfExists;
                        _f = {
                            key: 'location'
                        };
                        return [4 /*yield*/, recipient.getLocation];
                    case 2:
                        location = _e.apply(_d, [(_f.value = _k.sent(),
                                _f)]);
                        _h = (_g = Shipment).checkIfExists;
                        _j = {
                            key: 'subcontractor'
                        };
                        return [4 /*yield*/, __1.SubcoDigits.findSubcoByPostalCodeAndCountry(location.getPostalCode, location.getCountry)];
                    case 3:
                        subco = _h.apply(_g, [(_j.value = _k.sent(),
                                _j)]);
                        if (!(subco.getTag !== region)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.isMissorted(region, subcoId)];
                    case 4:
                        _k.sent();
                        return [2 /*return*/, {
                                belongsTo: subco.getTag,
                                correct: false,
                            }];
                    case 5: return [2 /*return*/, {
                            correct: true,
                        }];
                }
            });
        }); };
        _this.sortToCart = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = Shipment.checkIfExists({
                            key: 'id',
                            value: this.getId,
                        });
                        return [4 /*yield*/, Shipment.sortToCartByShipmentId(id, subcoId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        }); };
        _this.canTransitToState = function (stateName) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/can-transit-to-state", Model_1.METHOD.POST, {
                                shipmentId: this.getId,
                                stateName: stateName,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.transitToState = function (stateName) { return __awaiter(_this, void 0, void 0, function () {
            var sortedState, _a, _b, _c, id, recipientId, timeSlot;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = Shipment).checkIfExists;
                        _c = {
                            key: 'state'
                        };
                        return [4 /*yield*/, __1.State.fetchByName(stateName)];
                    case 1:
                        sortedState = _b.apply(_a, [(_c.value = _d.sent(),
                                _c)]);
                        id = Shipment.checkIfExists({ value: this.getId, key: 'ID' });
                        recipientId = Shipment.checkIfExists({
                            key: 'Recipient ID',
                            value: this.getRecipientId,
                        });
                        timeSlot = Shipment.checkIfExists({
                            key: 'TimeSlot ID',
                            value: this.getTimeSlot,
                        });
                        return [4 /*yield*/, new ShipmentLog_1.ShipmentLog(undefined, id, recipientId, sortedState.getId, timeSlot.getId, undefined, '123', null).save()];
                    case 2:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.isMissing = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.transitToState("EXCEPTION_SHIPMENT_MISSING")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        }); };
        _this.isMissorted = function (subcoRegion, subcoId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/missort/" + this.getId, Model_1.METHOD.POST, {
                            trunkrsNrOrBarcode: this.getTrunkrsNumber || this.getBarcode,
                            subcoRegion: subcoRegion,
                            subcoId: subcoId,
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLogs];
                }
            });
        }); };
        _this.deliver = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/deliver/" + this.id, Model_1.METHOD.POST, params)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLogs];
                }
            });
        }); };
        _this.deliverToNeighbour = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/deliver-to-neighbour/" + this.id, Model_1.METHOD.POST, params)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLogs];
                }
            });
        }); };
        _this.notDelivered = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/not-deliver/" + this.id, Model_1.METHOD.POST, params)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLogs];
                }
            });
        }); };
        _this.accept = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
            var result, newLog, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/accept-tour/" + this.getId, Model_1.METHOD.POST, { subcoId: subcoId })];
                    case 1:
                        result = _d.sent();
                        newLog = new ShipmentLog_1.ShipmentLog(result.id, result.shipmentId, result.recipientId, result.stateId, result.timeSlotId, 0, result.userSub, result.metaId);
                        _a = this;
                        if (!Config_1.config.getOption('updateNestedInstances')) return [3 /*break*/, 3];
                        _c = lodash_1.concat;
                        return [4 /*yield*/, this.getLogs];
                    case 2:
                        _b = _c.apply(void 0, [_d.sent(), [newLog]]);
                        return [3 /*break*/, 4];
                    case 3:
                        _b = [newLog];
                        _d.label = 4;
                    case 4:
                        _a.setLogs = _b;
                        return [2 /*return*/, this.getLogs];
                }
            });
        }); };
        _this.decline = function (reasonCode) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/decline-tour/" + this.getId, Model_1.METHOD.POST, {
                            reasonCode: reasonCode,
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getLogs];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.isMultiColli = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, false];
            });
        }); };
        /**
         * changeAddress
         * @param {IStopRequest} stopRequest
         */
        _this.changeAddress = function (stopRequest) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/change-shipment-address/" + this.getId, Model_1.METHOD.POST, stopRequest)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getLogs];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Fetch nested classes
         */
        _this.fetchLogs = function () {
            return _this.fetchNestedModel('setLogs', ShipmentLog_1.ShipmentLog.fetchLogsForShipment, 'getId', true);
        };
        _this.fetchMerchant = function () {
            return _this.fetchNestedModel('setMerchant', __1.Merchant.fetch, 'getMerchantId');
        };
        _this.fetchSender = function () {
            return _this.fetchNestedModel('setSender', __1.Sender.fetch, 'getSenderId');
        };
        _this.fetchRecipient = function () {
            return _this.fetchNestedModel('setRecipient', __1.Recipient.fetch, 'getLatestRecipientId');
        };
        _this.fetchHistoryDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/shipment-detail/" + this.id, Model_1.METHOD.GET)];
                    case 1:
                        result = _a.sent();
                        result = shipmentDetailsConvertTime_1.shipmentDetailsConvertTime(result);
                        this.setHistoryDetails = result;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fetchTimeSlot = function () { return __awaiter(_this, void 0, void 0, function () {
            var logs, _a, _b, v0, log, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.getLogs];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_d.sent()])];
                    case 2:
                        logs = (_d.sent());
                        v0 = logs.find(function (item) { return item.getVersion === 0; });
                        log = Shipment.checkIfExists({ value: v0, key: 'v0 shipment log' });
                        _c = this;
                        return [4 /*yield*/, log.getTimeSlot];
                    case 3:
                        _c.setTimeSlot = _d.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fetchProduct = function () {
            return _this.fetchNestedModel('setProduct', __1.Product.fetch, 'getProductId');
        };
        _this.fetchCollations = function () {
            return _this.fetchNestedModel('setCollations', __1.TourCollation.fetchByShipmentId, 'getId');
        };
        _this.fetchLastDriver = function () { return __awaiter(_this, void 0, void 0, function () {
            var collations, _a, getDriver;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = lodash_1.orderBy;
                        return [4 /*yield*/, this.getCollations];
                    case 1:
                        collations = _a.apply(void 0, [_b.sent(), 'id', 'desc']);
                        if (collations.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, collations[0].getTour];
                    case 2:
                        getDriver = (_b.sent()).getDriver;
                        return [4 /*yield*/, getDriver];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        }); };
        _this.fetchSubco = function () { return __awaiter(_this, void 0, void 0, function () {
            var recipient, location, subco;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRecipient];
                    case 1:
                        recipient = _a.sent();
                        return [4 /*yield*/, recipient.getLocation];
                    case 2:
                        location = _a.sent();
                        return [4 /*yield*/, __1.SubcoDigits.findSubcoByPostalCodeAndCountry(location.getPostalCode, location.getCountry)];
                    case 3:
                        subco = _a.sent();
                        if (!subco) {
                            throw new Error("No subcontractor found for shipment [" + this.getId + "], postal code: " + location.getPostalCode + ", country: " + location.getCountry);
                        }
                        this.setSubco = subco;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getId) return [3 /*break*/, 2];
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/" + this.getId, Model_1.METHOD.PUT, {
                                goods: this.getGoods,
                                remarks: this.getRemarks,
                                height: parseMeasurement_1.parseMeasurement(this.getHeight),
                                length: parseMeasurement_1.parseMeasurement(this.getLength),
                                weight: parseMeasurement_1.parseMeasurement(this.getWeight),
                                width: parseMeasurement_1.parseMeasurement(this.getWidth),
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this];
                }
            });
        }); };
        _this.fetchComments = function () {
            return _this.fetchNestedModel("setComments", ShipmentComment_1.ShipmentComment.fetchByShipmentId, "getId");
        };
        _this.cancel = function (cancelledBy, reason) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest(cancelledBy === 'TRUNKRS'
                            ? "/delivery/functions/cancelled-by-trunkrs/" + this.getId
                            : "/delivery/functions/cancelled-by-sender/" + this.getId, Model_1.METHOD.POST, { reason: reason })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLogs()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.changeReceiverAddress = function (changeAddressParams) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/change-shipment-address/" + this.getId, Model_1.METHOD.POST, {
                            location: changeAddressParams,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.overruleDelivered = function (comment, overrideDate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/final-state-delivered/" + this.getId, Model_1.METHOD.POST, {
                            comment: comment,
                            overrideDate: overrideDate,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.overruleDeliveredToNeighbor = function (comment, neighbour, overrideDate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/final-state-delivered-neighbor/" + this.getId, Model_1.METHOD.POST, {
                            comment: comment,
                            neighbour: neighbour,
                            overrideDate: overrideDate,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.overruleNotDelivered = function (comment, reasonCode, overrideDate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/final-state-not-delivered/" + this.getId, Model_1.METHOD.POST, {
                            comment: comment,
                            reasonCode: reasonCode,
                            overrideDate: overrideDate,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.overruleShipment = function (shipmentId, payload) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/set-final-state/" + shipmentId, Model_1.METHOD.POST, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.setTrunkrsNumber = trunkrsNumber;
        _this.setLabel = label;
        _this.setSenderId = senderId;
        _this.setRecipientId = recipientId;
        _this.setMerchantId = merchantId;
        _this.setProductId = productId;
        _this.setBarcode = barcode;
        _this.setWeight = weight;
        _this.setHeight = height;
        _this.setLength = length;
        _this.setWidth = width;
        _this.setGoods = goods;
        _this.setRemarks = remarks;
        _this.setMerchantDeliveryRemark = merchantDeliveryRemark;
        _this.setHistoryDetails = historyDetails;
        _this.neighborCardNumber = neighborCardNumber;
        return _this;
    }
    Object.defineProperty(Shipment.prototype, "getTrunkrsNumber", {
        /**
         * Getters
         */
        get: function () {
            return this.trunkrsNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getLabel", {
        get: function () {
            return this.label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getBarcode", {
        get: function () {
            return this.barcode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getProductId", {
        get: function () {
            return this.productId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getProduct", {
        get: function () {
            return this.checkIfPropertyIsFetched('product', this.fetchProduct);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getMerchantId", {
        get: function () {
            return this.merchantId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getMerchant", {
        get: function () {
            return this.checkIfPropertyIsFetched('merchant', this.fetchMerchant);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getHistoryDetails", {
        get: function () {
            return this.checkIfPropertyIsFetched('historyDetails', this.fetchHistoryDetails);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getSenderId", {
        get: function () {
            return this.senderId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getSender", {
        get: function () {
            return this.checkIfPropertyIsFetched('sender', this.fetchSender);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getRecipientId", {
        get: function () {
            return this.recipientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getRecipient", {
        get: function () {
            return this.checkIfPropertyIsFetched('recipient', this.fetchRecipient);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getNeighbor", {
        get: function () {
            return this.neighbor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getTimeSlot", {
        get: function () {
            return this.checkIfPropertyIsFetched('timeSlot', this.fetchTimeSlot);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getLogs", {
        get: function () {
            return this.checkIfPropertyIsFetched('logs', this.fetchLogs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getWeight", {
        get: function () {
            return this.weight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getHeight", {
        get: function () {
            return this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getLength", {
        get: function () {
            return this.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getWidth", {
        get: function () {
            return this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getGoods", {
        get: function () {
            return this.goods;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getCollations", {
        get: function () {
            return this.checkIfPropertyIsFetched('collations', this.fetchCollations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getCollation", {
        get: function () {
            return this.getCollations.then(function (collations) { return (collations || []).slice().pop(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getSubco", {
        get: function () {
            return this.checkIfPropertyIsFetched('subco', this.fetchSubco);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getLatestRecipientId", {
        get: function () {
            return this.getLatestRecipientIdLog();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getRemarks", {
        get: function () {
            return this.remarks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getMerchantDeliveryRemark", {
        get: function () {
            return this.merchantDeliveryRemark;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "getComments", {
        get: function () {
            return this.checkIfPropertyIsFetched("comments", this.fetchComments);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setTrunkrsNumber", {
        /**
         * Setters
         */
        set: function (trunkrsNumber) {
            this.trunkrsNumber = trunkrsNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setLabel", {
        set: function (label) {
            this.label = label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setBarcode", {
        set: function (barcode) {
            this.barcode = barcode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setProductId", {
        set: function (productId) {
            this.productId = productId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setProduct", {
        set: function (product) {
            this.product = product;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setMerchantId", {
        set: function (merchantId) {
            this.merchantId = merchantId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setHistoryDetails", {
        set: function (historyDetails) {
            this.historyDetails = historyDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setMerchant", {
        set: function (merchant) {
            this.merchant = merchant;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setSenderId", {
        set: function (senderId) {
            this.senderId = senderId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setSender", {
        set: function (sender) {
            this.sender = sender;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setRecipientId", {
        set: function (recipientId) {
            this.recipientId = recipientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setRecipient", {
        set: function (recipient) {
            this.recipient = recipient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setNeighbor", {
        set: function (neighbor) {
            this.neighbor = neighbor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setTimeSlot", {
        set: function (timeSlot) {
            this.timeSlot = timeSlot;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setLogs", {
        set: function (logs) {
            this.logs = logs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setWeight", {
        set: function (weight) {
            this.weight = weight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setHeight", {
        set: function (height) {
            this.height = height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setLength", {
        set: function (length) {
            this.length = length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setWidth", {
        set: function (width) {
            this.width = width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setGoods", {
        set: function (goods) {
            this.goods = goods;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setCollations", {
        set: function (collations) {
            this.collations = collations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setSubco", {
        set: function (subco) {
            this.subco = subco;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setComments", {
        set: function (comments) {
            this.comments = comments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setRemarks", {
        set: function (remarks) {
            this.remarks = remarks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shipment.prototype, "setMerchantDeliveryRemark", {
        set: function (merchantDeliveryRemark) {
            this.merchantDeliveryRemark = merchantDeliveryRemark;
        },
        enumerable: true,
        configurable: true
    });
    Shipment.checkIfExists = utils_1.checkIfPropertyExtists("Shipment");
    Shipment.sortToCartByShipmentId = function (id, subcoId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/sort-shipment-subdepot/" + id, Model_1.METHOD.POST, {
                        subcoId: subcoId,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Announce
     * Static method for creating a new shipment.
     * Requires the user to be a sender an to
     * be authorized via an API Key
     *
     * @param {IAnnounceParams} params
     * @returns {Promise<Shipment>}
     */
    Shipment.announce = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var shipment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest('/delivery/functions/announce-shipment', Model_1.METHOD.POST, {
                        options: {
                            timeSlotId: params.timeSlotId,
                        },
                        parcels: [
                            {
                                barcode: params.barcode,
                                goods: params.goods,
                                height: params.height,
                                length: params.length,
                                weight: params.weight,
                                width: params.width,
                            },
                        ],
                        receiver: params.receiver,
                        sender: params.sender,
                    })];
                case 1:
                    shipment = _a.sent();
                    return [2 /*return*/, new Shipment(shipment.parcels[0].id, shipment.parcels[0].trunkrsNr, shipment.parcels[0].label, shipment.parcels[0].barcode, shipment.parcels[0].product.id, shipment.sender.id, shipment.receiver.id, shipment.merchant.id, spliMeasurement_1.splitMeasurement(shipment.parcels[0].weight), spliMeasurement_1.splitMeasurement(shipment.parcels[0].height), spliMeasurement_1.splitMeasurement(shipment.parcels[0].length), spliMeasurement_1.splitMeasurement(shipment.parcels[0].width), shipment.parcels[0].goods)];
            }
        });
    }); };
    /**
     * fetch
     * fetch a shipment by its ID
     *
     * @param {number} shipmentId
     * @returns {Promise<Shipment>}
     */
    Shipment.fetch = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        var shipment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/" + shipmentId, Model_1.METHOD.GET)];
                case 1:
                    shipment = (_a.sent()).result;
                    return [2 /*return*/, new Shipment(shipment.id, shipment.trunkrsNr, 'test', shipment.barcode, shipment.productId, shipment.senderId, shipment.recipientId, shipment.merchantId, spliMeasurement_1.splitMeasurement(shipment.weight), spliMeasurement_1.splitMeasurement(shipment.height), spliMeasurement_1.splitMeasurement(shipment.length), spliMeasurement_1.splitMeasurement(shipment.width), shipment.goods, shipment.remarks, shipment.merchantDeliveryRemark)];
            }
        });
    }); };
    /**
     * fetch
     * fetch a shipment with details by its ID
     *
     * @param {number} shipmentId
     * @returns {Promise<Shipment>}
     */
    Shipment.fetchWithHistoryDetails = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/shipment-detail/" + shipmentId, Model_1.METHOD.GET)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, new Shipment(result.shipmentId, Number(result.trunkrsNr), 'test', result.barcode, result.productId, result.sender.id, result.recipient.id, result.merchantId, spliMeasurement_1.splitMeasurement(result.weight), spliMeasurement_1.splitMeasurement(result.height), spliMeasurement_1.splitMeasurement(result.length), spliMeasurement_1.splitMeasurement(result.width), result.goods, result.remarks, result.merchantDeliveryRemark, shipmentDetailsConvertTime_1.shipmentDetailsConvertTime(result), result.neighborCardNumber)];
            }
        });
    }); };
    /**
     * fetchAll
     * fetch all shipments (paginated)
     *
     * @param {number} page
     * @param {number} perPage
     * @returns {Promise<{ results: Shipment[], next: any }>}
     */
    Shipment.fetchAll = function (page, perPage) {
        if (page === void 0) { page = 0; }
        if (perPage === void 0) { perPage = 50; }
        return __awaiter(_this, void 0, void 0, function () {
            var count, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/count", Model_1.METHOD.GET, {
                            order: {
                                id: 'DESC',
                            },
                        })];
                    case 1:
                        count = (_a.sent()).result;
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/", Model_1.METHOD.GET, {
                                filter: {
                                    skip: page * perPage,
                                    take: perPage,
                                },
                                order: {
                                    id: 'DESC',
                                },
                            })];
                    case 2:
                        result = (_a.sent()).result;
                        return [2 /*return*/, {
                                next: count > (page + 1) * perPage
                                    ? function () { return Shipment.fetchAll(page + 1, perPage); }
                                    : undefined,
                                prev: page > 0 ? function () { return Shipment.fetchAll(page - 1, perPage); } : undefined,
                                results: result.map(function (shipment) {
                                    return new Shipment(shipment.id, shipment.trunkrsNr, 'test', shipment.barcode, shipment.productId, shipment.senderId, shipment.recipientId, shipment.merchantId, spliMeasurement_1.splitMeasurement(shipment.weight), spliMeasurement_1.splitMeasurement(shipment.height), spliMeasurement_1.splitMeasurement(shipment.length), spliMeasurement_1.splitMeasurement(shipment.width), shipment.goods, shipment.remarks, shipment.merchantDeliveryRemark);
                                }),
                            }];
                }
            });
        });
    };
    /**
     * searchShipment
     * Search a shipment with a text-based query
     *
     * @param {string} query
     * @returns {Promise<Shipment[]>}
     */
    Shipment.search = function (query) { return __awaiter(_this, void 0, void 0, function () {
        var searchResults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/search-shipment/", Model_1.METHOD.GET, {
                        query: query,
                    })];
                case 1:
                    searchResults = (_a.sent()).result;
                    if (!Array.isArray(searchResults)) {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, searchResults.map(function (result) {
                            return Shipment.fetch(result.searchable_id);
                        })];
            }
        });
    }); };
    /**
     * fetchByBarcode
     * fetch a shipment by its barcode
     *
     * @param {string} barcode
     * @returns {Promise<Shipment>}
     */
    Shipment.fetchByBarcode = function (barcode) { return __awaiter(_this, void 0, void 0, function () {
        var shipment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/findOne", Model_1.METHOD.GET, {
                        filter: {
                            where: [{ trunkrsNr: barcode }, { barcode: barcode }],
                        },
                    })];
                case 1:
                    shipment = (_a.sent()).result;
                    if (!shipment) {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, new Shipment(shipment.id, shipment.trunkrsNr, 'test', shipment.barcode, shipment.productId, shipment.senderId, shipment.recipientId, shipment.merchantId, spliMeasurement_1.splitMeasurement(shipment.weight), spliMeasurement_1.splitMeasurement(shipment.height), spliMeasurement_1.splitMeasurement(shipment.length), spliMeasurement_1.splitMeasurement(shipment.width), shipment.goods, shipment.remarks, shipment.merchantDeliveryRemark)];
            }
        });
    }); };
    Shipment.fetchShipmentIdByTrunkrsNrOrBarcode = function (trunkrsNrOrBarcode) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/shipment/findOne", Model_1.METHOD.GET, {
                        filter: {
                            select: ['id'],
                            where: [{ trunkrsNr: trunkrsNrOrBarcode }, { barcode: trunkrsNrOrBarcode }],
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, result];
            }
        });
    }); };
    /**
     * fetchSubcoShipments
     * fetch all shipments attached to a specific
     * subcontractor
     *
     * @param {number} subcoId
     * @param {boolean} noCache
     * @returns {Promise<any>}
     */
    Shipment.fetchSubcoShipments = function (subcoId, noCache) {
        if (noCache === void 0) { noCache = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var noCacheHeader, shipments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        noCacheHeader = noCache ? { 'Cache-Control': 'max-age=0' } : {};
                        return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/fetch-shipments-for-subcontractor/" + subcoId, Model_1.METHOD.GET, undefined, false, noCacheHeader)];
                    case 1:
                        shipments = _a.sent();
                        return [2 /*return*/, Promise.all(shipments.results.map(function (shipment) { return Shipment.fetch(shipment.id); }))];
                }
            });
        });
    };
    /**
     * fetchNonSortedByDate
     * fetch all non sorted shipments by date
     *
     * @param {moment.Moment} date
     * @returns {Promise<any>}
     */
    Shipment.fetchNonSortedByDate = function (date) { return __awaiter(_this, void 0, void 0, function () {
        var timeslots, _a, _b, _c, shipmentLogsForTimeSlot, _d, _e, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _b = (_a = Shipment).checkIfExists;
                    _c = {
                        key: 'Time Slot'
                    };
                    return [4 /*yield*/, __1.TimeSlot.findByDate(date.format('YYYY-MM-DD'))];
                case 1:
                    timeslots = _b.apply(_a, [(_c.value = _g.sent(),
                            _c)]);
                    _e = (_d = Shipment).checkIfExists;
                    _f = {
                        key: 'Shipment Logs'
                    };
                    return [4 /*yield*/, Promise.all(timeslots.map(function (timeslot) {
                            return ShipmentLog_1.ShipmentLog.fetchByTimeSlotId(timeslot.getId);
                        }))];
                case 2:
                    shipmentLogsForTimeSlot = _e.apply(_d, [(_f.value = _g.sent(),
                            _f)]);
                    return [4 /*yield*/, Promise.all(shipmentLogsForTimeSlot
                            .filter(function (item) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, item.getState];
                                case 1: return [2 /*return*/, (_a.sent()).getName === 'DATA_PROCESSED'];
                            }
                        }); }); })
                            .map(function (item) { return item.getShipment; }))];
                case 3: return [2 /*return*/, _g.sent()];
            }
        });
    }); };
    /**
     * setShipmentsToNotArrived
     * Set all non-sorted shipments of the day to the state
     * EXCEPTION_SHIPMENT_NOT_ARRIVED
     *
     * @returns {Promise<boolean>}
     */
    Shipment.setShipmentsToNotArrived = function () { return __awaiter(_this, void 0, void 0, function () {
        var shipments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.fetchNonSortedByDate(moment_1.default())];
                case 1:
                    shipments = _a.sent();
                    return [4 /*yield*/, Promise.all(shipments.map(function (shipment) {
                            return shipment.transitToState('EXCEPTION_SHIPMENT_NOT_ARRIVED');
                        }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
            }
        });
    }); };
    Shipment.saveShipmentsFromCsvFile = function (csvObject, merchantId) {
        return Shipment.makeRequest("/delivery/functions/save-shipments-from-csv", Model_1.METHOD.POST, {
            csvObject: csvObject,
            merchantId: merchantId,
        });
    };
    Shipment.printLabel = function (shipmentIdOrTrunkrsNr) {
        return Shipment.makeRequest("/delivery/functions/print-label-via-trunkrsnr/" + shipmentIdOrTrunkrsNr, Model_1.METHOD.GET, undefined, undefined, {
            'accept': 'application/pdf',
        }, undefined, 'arraybuffer');
    };
    Shipment.printReturnToSenderLabel = function (barcodeOrTrunkrsNr) {
        return Shipment.makeRequest("/delivery/functions/create-return-to-sender-label", Model_1.METHOD.GET, { barcodeOrTrunkrsNr: barcodeOrTrunkrsNr });
    };
    /**
     * @deprecated sortShipment use .sort()
     * Sorts shipment and returns its region
     * @param {args: string | number} param
     * @returns {Promise<string>}
     */
    Shipment.sortShipment = function (param) { return __awaiter(_this, void 0, void 0, function () {
        var result, shipment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/sort-shipment-fetch-region", Model_1.METHOD.POST, param)];
                case 1:
                    result = _a.sent();
                    shipment = new Shipment(result.id, result.trunkrsNr, 'test', result.barcode, result.productId, result.senderId, result.recipientId, result.merchantId, spliMeasurement_1.splitMeasurement(result.weight), spliMeasurement_1.splitMeasurement(result.height), spliMeasurement_1.splitMeasurement(result.length), spliMeasurement_1.splitMeasurement(result.width), result.goods, result.remarks, result.merchantDeliveryRemark);
                    return [2 /*return*/, {
                            shipment: shipment,
                            stateId: result.stateId,
                            region: result.region,
                            countryCode: result.countryCode,
                        }];
            }
        });
    }); };
    /**
     * sort
     * Sorts shipment and returns its region
     * @param {args: string | number} param
     * @returns {Promise<string>}
     */
    Shipment.sort = function (param) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/sort-shipment-to-region", Model_1.METHOD.POST, param)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    Shipment.regionSort = function (networkType, date, barcodes) {
        if (barcodes === void 0) { barcodes = []; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/hand-sorting/shipment/region", Model_1.METHOD.POST, {
                            barcodes: barcodes,
                            networkType: networkType,
                            date: date,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Shipment.hubSort = function (networkType, date, barcodes) {
        if (barcodes === void 0) { barcodes = []; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/private/hand-sorting/shipment/hub", Model_1.METHOD.POST, {
                            barcodes: barcodes,
                            networkType: networkType,
                            date: date,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Shipment.getDeliveryDetails = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Shipment.makeRequest("/delivery/functions/get-delivery-details/" + shipmentId, Model_1.METHOD.GET)];
        });
    }); };
    Shipment.getTodoListShipments = function (subcoId) {
        return Shipment.makeRequest("/delivery/private/shipments-lacking-end-states/" + subcoId, Model_1.METHOD.GET);
    };
    Shipment.markTodoShipmentProcessed = function (shipmentId, statusRemark) {
        return Shipment.makeRequest("/delivery/private/todo-shipments-processed/", Model_1.METHOD.POST, { shipmentId: shipmentId, statusRemark: statusRemark });
    };
    Shipment.batchPostpone = function (shipmentIdOrBarcode, date, userSub) {
        return Shipment.makeRequest("/delivery/private/batch-postpone/", Model_1.METHOD.POST, {
            shipmentIdOrBarcode: shipmentIdOrBarcode,
            date: date,
            userSub: userSub,
        });
    };
    Shipment.bulkCancel = function (shipmentIdOrBarcode, userSub, comment) {
        return Shipment.makeRequest("/delivery/private/batch-cancel/", Model_1.METHOD.POST, {
            shipmentIdOrBarcode: shipmentIdOrBarcode,
            userSub: userSub,
            comment: comment,
        });
    };
    Shipment.fetchShipmentStates = function (shipmentIds, lastUpdated) {
        return Shipment.makeRequest('/delivery/functions/fetch-shipment-states', Model_1.METHOD.PUT, {
            shipmentIds: shipmentIds,
            lastUpdated: lastUpdated,
        });
    };
    Shipment.confirmReturnedToTrunkrs = function (barcode) {
        return Shipment.makeRequest('/delivery/functions/confirm-returned-to-trunkrs', Model_1.METHOD.POST, { barcode: barcode });
    };
    Shipment.getShipmentsReturnedToTrunkrs = function (region, subcoId, date) { return Shipment.makeRequest('/delivery/functions/shipments-returned-to-trunkrs', Model_1.METHOD.GET, { region: region, subcoId: subcoId, date: date }); };
    Shipment.fetchCSPReturnsList = function (payload) { return Shipment.makeRequest('/delivery/private/fetch-csp-returns-list', Model_1.METHOD.GET, payload); };
    Shipment.printShipmentsReturnedToTrunkrs = function (region, subcoId, date) { return Shipment.makeRequest('/delivery/functions/create-shipments-returned-to-trunkrs-pdf', Model_1.METHOD.GET, { region: region, subcoId: subcoId, date: date }); };
    Shipment.fetchHubLogsByShipmentId = function (shipmentId) {
        return Shipment.makeRequest("/delivery/functions/fetch-shipment-hub-logs/" + shipmentId, Model_1.METHOD.GET);
    };
    /**
     * Fetch all hublog items for the current subcontractor/partner
     *
     * @param subcoId current subcontractor/partner id
     * @param trunkrsNrOrBarcode if provided, return hublog item related to
     * @returns arrays of HublogItem
     */
    Shipment.fetchHubLogsBySubCoId = function (subcoId, trunkrsNrOrBarcode) { return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/delivery/private/fetch-hublogs-inventory-list/" + subcoId;
                    if (trunkrsNrOrBarcode) {
                        url += "?trunkrsNrOrBarcode=" + trunkrsNrOrBarcode;
                    }
                    return [4 /*yield*/, Shipment.makeRequest(url, Model_1.METHOD.GET)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    Shipment.addHubLogState = function (payload) {
        return Shipment.makeRequest("/delivery/private/add-hub-log-state", Model_1.METHOD.POST, payload);
    };
    Shipment.returnScan = function (payload) {
        return Shipment.makeRequest("/delivery/functions/return-scan", Model_1.METHOD.POST, payload);
    };
    Shipment.fetchReturnScans = function (shipmentId) {
        return Shipment.makeRequest("/delivery/functions/return-scan?" + query_string_1.default.stringify({ shipmentId: shipmentId }), Model_1.METHOD.GET);
    };
    Shipment.batchHubOut = function (payload, inventoryScanCompleted) {
        return Shipment.makeRequest("/delivery/functions/batch-hub-out", Model_1.METHOD.POST, {
            payload: payload,
            inventoryScanCompleted: inventoryScanCompleted,
        });
    };
    /**
     * Mark shipment as next step
     *
     * @param trunkrsNrOrBarcode trunkrsNr or barcode of shipment
     * @param subcoId current subcontractor/partner id
     * @returns Object of type and shipmentData as optional, it will be returned when payload trunkrsNrOrBarcode is not available at fetchHubLogsBySubCoId
     */
    Shipment.markShipmentAsNextStep = function (trunkrsNrOrBarcode, subcoId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Shipment.makeRequest("/delivery/functions/morning-scan", Model_1.METHOD.POST, {
                        trunkrsNrOrBarcode: trunkrsNrOrBarcode,
                        subcoId: subcoId,
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    Shipment.fetchReturnedShipments = function (subcoId, date) {
        var payload = {
            date: lodash_1.defaultTo(date, moment_1.default().format("YYYY-MM-DD")),
            subcoId: subcoId,
        };
        return Shipment.makeRequest("/delivery/functions/shipments/morning-scan?" + query_string_1.default.stringify(payload), Model_1.METHOD.GET);
    };
    Shipment.scanReturnedShipments = function (payload) {
        return Shipment.makeRequest("/delivery/private/scan-returned-shipment", Model_1.METHOD.POST, payload);
    };
    Shipment.massApplyState = function (payload) {
        if (payload.shipmentIds.length > 100) {
            throw new Error("endpoint can only take up to 100 shipment per request");
        }
        return Shipment.makeRequest('/delivery/functions/set-mass-states', Model_1.METHOD.POST, payload);
    };
    /**
     * Mark a shipment as not scannable
     * @param payload accepts unscannableReasonId, shipmentIds, and comment
     * @returns
     */
    Shipment.markShipmentAsUnscannable = function (payload) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Model_1.Model.makeRequest('/delivery/functions/unscannable-reason', Model_1.METHOD.PUT, payload)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    Shipment.getProofOfDeliveryByShipmentId = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Shipment.makeRequest("/delivery/functions/proof-of-delivery/" + shipmentId, Model_1.METHOD.GET)];
        });
    }); };
    Shipment.getShipmentAuditLogsByShipmentId = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Shipment.makeRequest("/delivery/functions/shipment-audit-logs/" + shipmentId, Model_1.METHOD.GET)];
        });
    }); };
    Shipment.fetchFilteredShipment = function (params) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Shipment.makeRequest("/search/shipment", Model_1.METHOD.GET, params)];
        });
    }); };
    /**
     * Get capacity slot details
     *
     * @param date string format 'YYYY-MM-DD'
     * @param networkType 'NIGHT'|'DAY'
     * @returns Promise<ICapacitySlot>
     */
    Shipment.getCapacitySlotStatus = function (date, networkType) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Shipment.makeRequest("/delivery/functions/capacity-slots/status/" + date + "/" + networkType, Model_1.METHOD.GET)];
        });
    }); };
    return Shipment;
}(Model_1.Model));
exports.Shipment = Shipment;
